import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import HomeIcon from '@mui/icons-material/Home';

import useStore from '../store/useStore';

import { translations } from '../translations';

export default function NotFoundPage() {
  const { language } = useStore();

  const t = translations[language];

  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',

          flexDirection: 'column',

          alignItems: 'center',

          justifyContent: 'center',

          minHeight: '100vh',

          textAlign: 'center',
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 6,

            borderRadius: 8,

            bgcolor: 'transparent',

            display: 'flex',

            flexDirection: 'column',

            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              fontSize: '120px',

              fontWeight: 900,

              color: 'primary.light',

              lineHeight: 1,

              mb: 2,

              opacity: 0.5,
            }}
          >
            404
          </Box>

          <SentimentVeryDissatisfiedIcon
            sx={{ fontSize: 80, color: 'primary.main', mb: 4 }}
          />

          <Typography variant="h3" sx={{ fontWeight: 800, mb: 2 }}>
            {t.pageNotFound}
          </Typography>

          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ mb: 6, maxWidth: 500 }}
          >
            {language === 'en'
              ? 'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.'
              : 'Страница, которую вы ищете, могла быть удалена, переименована или временно недоступна.'}
          </Typography>

          <Button
            variant="contained"
            size="large"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/')}
            sx={{
              px: 4,

              py: 1.5,

              borderRadius: 4,

              fontSize: '1.1rem',

              boxShadow: '0 8px 20px rgba(79, 70, 229, 0.3)',
            }}
          >
            {t.goHome}
          </Button>
        </Paper>
      </Box>
    </Container>
  );
}
